import { createAction } from '@reduxjs/toolkit'

import { InternalAccount, InternalNpsPeriod } from 'types/GlobalInternalAccount'

// tryGetAllAccounts
export const getAll = createAction('internal_get_all_accounts')
export const getAllSuccess = createAction<InternalAccount[]>(
  'internal_get_all_accounts_success'
)
export const getAllFailed = createAction('internal_get_all_accounts_failed')

// tryGetOneAccount, tryUpdateAccount
export const getOneSuccess = createAction<InternalAccount>(
  'internal_get_one_account_success'
)

// tryGetAccountNps
export const getNpsSuccess = createAction<{
  id: string
  periods: InternalNpsPeriod[]
}>('internal_get_account_nps_success')
